import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function TenantPicker({ tenants, value, onChange }) {
  const [open, setOpen] = useState(false);
  const cur = tenants.find((t) => t.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="h-10 w-full justify-between bg-white font-normal sm:w-80" data-testid="crm-tenant-select">
          <span className="truncate">{cur ? cur.name : "Scegli il cliente"}</span><ChevronsUpDown size={14} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="end">
        <Command>
          <CommandInput placeholder="Cerca cliente…" data-testid="crm-tenant-search" />
          <CommandList>
            <CommandEmpty>Nessun cliente trovato.</CommandEmpty>
            {tenants.map((t) => (
              <CommandItem key={t.id} value={`${t.name} ${t.id}`} onSelect={() => { onChange(t.id); setOpen(false); }} data-testid={`crm-tenant-option-${t.id}`}>
                <Check size={14} className={`mr-2 ${t.id === value ? "opacity-100" : "opacity-0"}`} /><span className="truncate">{t.name}</span>{t.status === "archived" && <span className="ml-2 shrink-0 rounded bg-slate-100 px-1.5 py-0.5 text-[10px] text-slate-500">archiviato</span>}
              </CommandItem>))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
